import * as angular from 'angular';
import Controller from './checkListKPI.controller';
import dashboardTemplate from './checkListKPI.dashboard.tpl.html';
import lineSheetTemplate from './checkListKPI.linesheet.tpl.html';

let name = 'aps.directive.checkListKPI';
export default name;
let ngModule = angular.module(name, [Controller]);

function registerDirective(name: string, template: string) {
  let checkListKPIDef = () => {
    return {
      restrict: 'E',
      template: template,
      replace: true,
      controller: 'CheckListKPICtrl',
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        plantId: '=',
        shopId: '=',
        wellKnownCheck: '='
      }
    };
  };

  let directiveName = 'apsCheckListKpi' + name;
  ngModule.directive(directiveName, checkListKPIDef);
}

registerDirective("Dashboard", dashboardTemplate);
registerDirective("Linesheet", lineSheetTemplate);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/checkLists/checkListKPI.directive.ts